import { render, staticRenderFns } from "./SearchChat.vue?vue&type=template&id=58939e90&scoped=true"
import script from "./SearchChat.vue?vue&type=script&lang=js"
export * from "./SearchChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58939e90",
  null
  
)

export default component.exports